import React from "react";
import {registerPassages, jumpTo} from "../../Utils";
import {addTimePart} from "../features/functions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import images, {getRandomImage} from "../images";
import variables from "../variables";
import places from "../places/places";
import conditions from "../conditions";
import people, {currentPlayer} from "../people/people";
import Say from "../../features/Say";
import constants from "../constants";
import missions from "../missions";
import things from "../things";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

registerPassages({
    chat: <Passage>
        <Trans i18nKey="wife.chat">
            1<h1/><V callback={() => (<Image src={getRandomImage(images.wife.actions.speak)}/>)}/>
            <Name who={people.wife}/>
            <Link to="" callback={() => {
                people.wife.set("relations", people.wife.relations + 1);
                currentPlayer.goTo(people.wife.where);
                addTimePart(true);}}/>
            {{wife: people.wife.name}}
        </Trans>
    </Passage>,

    makeOut: <Passage>
        <V callback={() => {
            if (!conditions.wifeKissingAvailable())
                jumpTo("wife.busy");
        }}/>
        <Trans i18nKey="wife.makeOut">
            1<h1/><V callback={() => (<Image src={getRandomImage(images.wife.actions.kiss)}/>)}/>
            <Say who={people.player}/>
            <Link to="" callback={() => {
                currentPlayer.goTo(people.wife.where);}}/>
            {{wife: people.wife.name}}
        </Trans>
    </Passage>,

    busy: <Passage>
        <Trans i18nKey="wife.busy">
            1<h1/><V callback={() => (<Image src={getRandomImage(images.wife.actions.busy)}/>)}/>
            <Say who={people.wife}/><Name who={people.wife}/>
            <Link to="" callback={() => {
                people.wife.set("relations", people.wife.relations - 1);
                currentPlayer.goTo(people.wife.where);}}/>
            {{wife: people.wife.name}}
        </Trans>
    </Passage>,

    howSheFeels: <Passage>
        <Trans i18nKey="wife.howSheFeels.part1">
            1<h1/><V callback={() => (<Image src={getRandomImage(images.wife.actions.speak)}/>)}/>
            <Say who={people.player}/>{{wife: people.wife.name}}
        </Trans>
        <V callback={() => {
            if (!conditions.wifeHowFeelsTalk())
                return (
                    <div>
                        <Trans i18nKey="wife.howSheFeels.part2">
                            1<Say who={people.wife}/><span style={{color: "red"}}/><br/>
                            <Link to="" callback={()=>{currentPlayer.goTo(people.wife.where)}}/>{{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
            else if (conditions.wifeHowFeelsTalkPillsTreated())
                return (
                    <div>
                        <Trans i18nKey="wife.howSheFeels.part3">
                            1<Say who={people.wife}/><Say who={people.player}/><Say who={people.wife}/>
                            <Link to="" callback={() => {
                                if (missions.initCorruption_01.tasks.checkChanges_01.isActive()) {
                                    things.pillForJob.treat();
                                    missions.initCorruption_01.finishCurrentTask(false);
                                }
                                people.wife.occupations.set(people.wife.occupations.sleep.id);
                                variables.game.dateWifeTreatedPill = 0;
                                currentPlayer.goTo(places.homeKitchen.id);}}/>
                        </Trans>
                    </div>
                )
            else
                return (
                    <div>
                        <Trans i18nKey="wife.howSheFeels.part4">
                            1<Say who={people.wife}/><Say who={people.player}/><Name who={people.wife}/>
                            <Link to="" callback={()=>currentPlayer.goTo(people.wife.where)}/>{{wife: people.wife.name}}
                        </Trans>
                    </div>
                )
        }}/>
    </Passage>,

    watchPorn: <Passage>
        <Image src={images.wife.actions.no}/>
        <Trans i18nKey="wife.watchPorn">
            1<Say who={people.wife}/><div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{
                currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>,

    dressUp: <Passage>
        <V callback={()=>{
            currentPlayer.goTo(places.wifeDressUpMenu.id);
        }}/>
    </Passage>,

    undress: <Passage>
        TODO
        <V callback={()=>{
            variables.wife.isDressedUp = false;
            currentPlayer.goTo(places.homeBedroom.id);
        }}/>
    </Passage>,

    bathTogether: <Passage>
        <V callback={()=>{!conditions.bathTogether() && jumpTo("wife.bathTogetherDeny")}}/>
        <Trans i18nKey="wife.bathTogether">
            1<Say who={people.player}/><Say who={people.wife}/><br/>
            <V callback={() => (<Image src={getRandomImage(images.wife.actions.shower.washTogether)}/>)}/>
            <Link to="" callback={()=>{
                addTimePart(true);
                currentPlayer.goTo(places.homeBathroom.id);}}/>
        </Trans>
    </Passage>,

    bathTogetherDeny: <Passage>
        <Image src={images.wife.occupations.shower.showerNo}/>
        <Trans i18nKey="wife.bathTogetherDeny">
            1<Say who={people.wife}/><div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{
                currentPlayer.goTo(places.homeBathroom.id);}}/>
            {{player: people.player.name, conditions: constants.wife.relationsTo.bathTogether}}
        </Trans>
    </Passage>,

    checkHerAss: <Passage>
        <V callback={()=>{
            people.wife.relations <= constants.wife.relationsTo.checkHerAss && jumpTo("wife.checkHerAssFailure");
            people.wife.relations > constants.wife.relationsTo.checkHerAss && jumpTo("wife.checkHerAssSuccess");
        }}/>
    </Passage>,

    checkHerAssFailure: <Passage>
        <Trans i18nKey="wife.checkHerAssFailure">
            1<Name who={people.wife}/><Say who={people.wife}/><Say who={people.player}/><div style={{color: "red"}}/><br/>
            <Link to="" callback={ () => currentPlayer.goTo(places.homeBedroom.id) }/>
            {{player: people.player.name, relations: constants.wife.relationsTo.checkHerAss}}
        </Trans>
    </Passage>,

    checkHerAssSuccess: <Passage>
        <Trans i18nKey="wife.checkHerAssSuccess">
            1<Name who={people.wife}/><V callback={() => (<Image src={getRandomImage(images.wife.actions.undercoves)}/>)}/>
            <br/><Link to="" disabled={true}/><Link to="" callback={()=>{currentPlayer.goTo(places.homeBedroom.id)}}/>
        </Trans>
    </Passage>,

    handsJob: <Passage>
        <Trans i18nKey="wife.handsJob">
            1<h1/><Image src={images.wife.actions.argue.no_bed2}/><Say who={people.wife}/><div style={{color: "red"}}/>
            <br/><Link to="" callback={()=>{currentPlayer.goTo(people.wife.where)}}/>
        </Trans>
    </Passage>,

    blowjob: <Passage>
        <Trans i18nKey="wife.blowjob">
            1<h1/><Image src={images.wife.actions.argue.no_bed2}/><Say who={people.wife}/><div style={{color: "red"}}/>
            <br/><Link to="" callback={()=>{currentPlayer.goTo(people.wife.where)}}/>
        </Trans>
    </Passage>,

    sex: <Passage>
        <V callback={()=>{
            people.wife.relations <= constants.wife.relationsTo.askForSex && jumpTo("wife.sexNegative");
            people.wife.relations > constants.wife.relationsTo.askForSex &&
            people.wife.relations <= constants.wife.relationsTo.haveSex &&
            jumpTo("wife.sexNo");
            people.wife.relations > constants.wife.relationsTo.haveSex && jumpTo("wife.sexYes");
        }}/>
    </Passage>,

    sexNegative: <Passage>
        <Trans i18nKey="wife.sexNegative">
            1<h1/><Image src={images.wife.actions.argue.no_bed2}/><Say who={people.wife}/><div style={{color: "red"}}/><br/>
            <Link to="" callback={()=>{
                people.wife.set("relations", people.wife.relations - 1);
                currentPlayer.goTo(people.wife.where);}}/>
            {{player: people.player.name, relations: constants.wife.relationsTo.askForSex}}
        </Trans>
    </Passage>,

    sexNo: <Passage>
        <Trans i18nKey="wife.sexNo">
            1<h1/><Image src={images.wife.actions.speak["04"]}/><Say who={people.wife}/><div style={{color: "red"}}/>
            <br/><Link to="" callback={()=>{currentPlayer.goTo(people.wife.where)}}/>
            {{player: people.player.name, relations: constants.wife.relationsTo.haveSex}}
        </Trans>
    </Passage>,

    sexYes: <Passage>
        <Trans i18nKey="wife.sexYes">
            1<h1/><Name who={people.wife}/><Say who={people.wife}/><Say who={people.player}/>
            <Image src={images.wife.actions.sex.neckKiss}/><Image src={images.wife.actions.sex.bra01}/>
            <Image src={images.wife.actions.sex.tits01}/>
            <V callback={() => (<Image src={getRandomImage(images.wife.actions.sex.fingering)}/>)}/>
            <V callback={() => (<Image src={getRandomImage(images.wife.actions.sex.sex01)}/>)}/>
            <V callback={() => (<Image src={getRandomImage(images.wife.actions.sex.cum01)}/>)}/>
            <Name who={people.wife} nickname/>
            <Link to="" callback={()=>{
                people.wife.set("relations", people.wife.relations + 1);
                const placeId = people.wife.where;
                addTimePart(true);
                currentPlayer.goTo(placeId);}}/>
            {{player: people.player.name}}
        </Trans>
    </Passage>,

    analSex: <Passage>
        <Trans i18nKey="wife.analSex">
            1<h1/><Image src={images.wife.actions.argue.no_bed2}/><Say who={people.wife}/><div style={{color: "red"}}/>
            <br/><Link to="" callback={()=>{currentPlayer.goTo(people.wife.where)}}/>
        </Trans>
    </Passage>

}, "wife")